// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"style_appWrapper__wG-aP","contentWrapper":"style_contentWrapper__7y3LX","menu":"style_menu__3EKZf","icon":"style_icon__31nMg"};